import { ThemeOptions } from '@mui/material/styles';
import {palette} from "./constants";

export const getOverrides = (theme: ThemeOptions): ThemeOptions['components'] => {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: ' "Segoe", "Noto Sans", Helvetica, Arial, sans-serif',
          fontSize: '14px',
          padding: '14px 34px',
          fontWeight: 'bold',
          borderRadius: '28px',
          transition: '0.2s',
          borderWidth: '2px',
          borderStyle: 'solid',
          lineHeight: '1.285',
          minHeight: '51px',
          minWidth: '110px',
        },
        outlined: {
          backgroundColor: 'transparent',
          color: '#fff',
          borderColor: '#fff',
          '&:hover': {
            color: '#000',
            backgroundColor: '#fff',
          },
        },
        containedPrimary: {
          backgroundColor: palette.primary.main,
          color: '#fff',
          borderColor: palette.primary.main,
          '&:hover': {
            color: `${palette.primary.main} !important`,
            backgroundColor: 'transparent !important',
          },
          '&:disabled': {
            backgroundColor: '#75757533 !important',
            color: '#FFFFFF !important',
            borderStyle: 'none',
          },
        },
        outlinedPrimary: {
          color: '#fff',
          borderColor: palette.primary.main,
          '&:hover': {
            color: '#fff',
            backgroundColor: palette.primary.main,
          },
        },
        containedSecondary: {
          backgroundColor: palette.secondary.main,
          color: '#fff',
          borderColor: palette.secondary.main,
          '&:hover': {
            color: palette.secondary.main,
            backgroundColor: 'transparent',
          },
        },
        outlinedSecondary: {
          color: '#fff',
          borderColor: palette.secondary.main,
          '&:hover': {
            color: '#fff',
            backgroundColor: palette.secondary.main,
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: '20px',
          paddingRight: '20px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': {
            borderRadius: '50px',
          },
        },
        notchedOutline: {
          border: 0,
          '&:hover fieldset': {
            border: 0,
          },
          '&.Mui-focused': {
            border: 0,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        colorPrimary: {
          color: palette.primary.main,
        },
      },
    },
  };
};
